import { useState, useEffect } from 'react';
import type { PresentViewMode } from '@/components/panels/PresentEntry';

const STORAGE_KEY = 'present-view-mode';

/**
 * Persisted view-mode toggle for the lobby "Present" list (icons vs. list),
 * backed by localStorage so the choice survives reloads.
 */
export function usePresentViewMode(): [PresentViewMode, (mode: PresentViewMode) => void] {
  const [mode, setMode] = useState<PresentViewMode>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored === 'list' || stored === 'icons' ? stored : 'icons';
    } catch (error) {
      console.error('Failed to read present view mode:', error);
      return 'icons';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (error) {
      console.error('Failed to save present view mode:', error);
    }
  }, [mode]);

  return [mode, setMode];
}
